module.exports = __webpack_public_path__ + "static/media/ipad3.1d808789.png";